

  
const content = `# Uninstall OnData SecureFile

## Uninstall SecureFile on Windows
  
Follow the steps below to uninstall the OnData SecureFile application on Windows:  
a. Ensure you have logged in with an administrative account to your computer so that you can uninstall applications  
b. Navigate to \`Settings\` -> \`Apps\` -> \`Installed apps\`  
c. Locate the \`OnData SecureFile\` application from the list and click on the ellipsis (three dots) on the right side  
d. Select the \`Uninstall\` option and follow the wizard to uninstall the OnData SecureFile application. You may be prompted to reboot your computer after uninstallation  
  

## Uninstall SecureFile on MacOS
  
A shell script is provided below to cleanly uninstall the OnData SecureFile application on MacOS. You must be signed in as an administrator on the Mac or 
provide an administrator name and password to run this script using the \`Terminal\` application.  

When executing the following script from the \`Terminal \` application, the system may prompt you to allow the \`Terminal\` application to access data from other apps, as 
well as permission to control \`System Events\`. Please respond with the \`Allow\` option in both cases.  

\`\`\`Bash
#!/bin/bash

echo "Uninstall OnData SecureFile..."

APP_NAME="OnData SecureFile"
APP_IDENTIFIER="com.ondata.mac.OnDataSecureFile-SwiftUI"

sudo pkill -9 "$APP_NAME" 
sudo killall -9 "$APP_NAME"

APP_PATH="/Applications/$APP_NAME.app"
if [ -d "$APP_PATH" ]; then
    sudo rm -rf "$APP_PATH"
    echo "$APP_PATH has been deleted."
else
    echo "$APP_PATH does not exist. Skip this step."
fi

sudo rm -rf ~/Library/Preferences/com.ondata.shared.plist
sudo rm -rf ~/Library/Preferences/"$APP_IDENTIFIER".plist
sudo rm -rf ~/Library/Caches/"$APP_IDENTIFIER"
sudo rm -rf ~/Library/Application\\ Support/OnData
sudo rm -rf ~/OnData
sudo rm -rf ~/Library/Containers/"$APP_IDENTIFIER"
sudo rm -rf ~/Library/Containers/OnDataSecurFile.FinderSync
sudo rm -rf ~/Library/Containers/OnDataSecurFile.Thumbnail
sudo rm -rf ~/Library/Containers/com.ondata.mac.OnDataSecureFile-SwiftUI.OnDataSecureFile-Thumbnail
sudo rm -rf ~/Library/Containers/com.ondatahub.mac.OnDataSecureFile-SwiftUI.OnDataSecureFile-Thumbnail
sudo rm -rf ~/Library/Containers/com.ondata.mac.OnDataSecureFile-SwiftUI.OnDataSecureFile-FinderSync

osascript -e 'Tell application "System Events" to delete login item "OnData SecureFile"'

# Handle OnData DataManager
# Kill the DataManager process
sudo pkill -9 "OnData.DataManager.HostApp" 
sudo killall -9 "OnData.DataManager.HostApp"
sudo rm -rf /Library/Application\\ Support/OnData
sudo rm -f /Library/LaunchAgents/com.ondata.mac.datamanager.plist


echo "OnData SecureFile has been successfully uninstalled."
\`\`\`
  
  `
  
export default content;
